import  * as schema from 'yup';
import { SmartChargingFormModal } from '../models/integrationSettings';
import { URL_PATTERN } from '@/common/constants/constants';

export const smartChargingFormSchema = schema.object<Partial<Record<keyof SmartChargingFormModal, schema.AnySchema>>>({
	user: schema.string().required('general.mandatory_field').matches(/^.{0,100}$/, 'general.error_max_length'),
	password: schema.string().required('general.mandatory_field'),
	optimizerUrl: schema.string().required('general.mandatory_field').matches(URL_PATTERN, 'general.error_url_pattern'),
});